import React from 'react';
import { useTranslation } from 'react-i18next';
import { Mail } from 'lucide-react';
import SaasSection from '../saas/Section';
import SaasContainer from '../saas/Container';

const NewsletterSection = () => {
  const { t } = useTranslation();
  return (
    <SaasSection variant="canvas" className="landing-section-loose !pb-16 !pt-12 md:!pb-20">
      <SaasContainer>
        <div className="mx-auto flex max-w-xl flex-col items-center text-center">
          <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-sky-wash to-card-surface text-signal shadow-saas ring-1 ring-hairline/45 md:mb-6 md:h-16 md:w-16">
            <Mail className="h-7 w-7 stroke-[1.75] md:h-8 md:w-8" strokeLinecap="round" strokeLinejoin="round" aria-hidden />
          </div>
          <p className="type-eyebrow mb-3 text-steel">{t('newsletter.eyebrow', { defaultValue: 'خبرنامه' })}</p>
          <h2 className="type-section-title mb-4 text-2xl md:text-heading-lg">
            {t('newsletter.title')}
          </h2>
          <p className="type-lead mb-8 max-w-md">{t('newsletter.description')}</p>
          <div className="flex w-full items-stretch overflow-hidden rounded-[2rem] border border-hairline/50 bg-card-surface p-1.5 shadow-saas ring-1 ring-signal/[0.06]">
            <input
              type="email"
              placeholder={t('newsletter.placeholder')}
              className="min-w-0 flex-1 border-0 bg-transparent px-4 py-3 text-sm text-ink-graphite outline-none ring-0 placeholder:text-fog focus:outline-none focus:ring-0"
            />
            <button
              type="button"
              className="type-button shrink-0 rounded-[1.35rem] bg-cta-gradient px-5 py-3 text-sm text-white transition hover:brightness-105 sm:px-6"
            >
              {t('newsletter.submit')}
            </button>
          </div>
        </div>
      </SaasContainer>
    </SaasSection>
  );
};

export default NewsletterSection;
